import { put, call, takeLatest } from 'redux-saga/effects'

import { getVendors as getVendorsApi } from 'Service/Api'

import * as VendorTypes from 'Redux/Types/VendorTypes'
import * as VendorActions from 'Redux/Actions/VendorActions'

function* getVendors({ payload }) {
  try {
    const response = yield call(getVendorsApi, payload)
    yield put(VendorActions.getVendorsSucceeded(response))
  } catch (errors) {
    yield put(VendorActions.getVendorsFailed(errors))
  }
}

export default function* VendorSaga() {
  yield takeLatest(VendorTypes.GET_VENDORS, getVendors)
}
